import { GlobalToken } from 'antd';
import styled from 'styled-components';
import { breakpoints } from '@/utils/util-breakpoints';

export const UnifiedFormContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: ${({ theme: { token } }) => token.colorText};
  padding: 0;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 ${({ theme: { token } }) => token.paddingLG}px;
  }

  @media (max-width: ${breakpoints.lg - 1}px) {
    .unified-site-survey-form {
      padding-bottom: 6.5rem;
    }
  }

  .welcome-section {
    width: 100%;
  }

  .account-input-item {
    width: 100%;
  }

  .unified-site-survey-form {
    width: 100%;
    max-width: 62.625rem;
    display: flex;
    flex-direction: column;
  }

  .home-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
  }

  .content-step {
    align-items: flex-start;

    .welcome-title,
    .welcome-description {
      text-align: left;
    }

    .form-container {
      max-width: 100%;
    }
  }

  .input-wrapper {
    width: 100%;
    max-width: 17.5rem;
    background: transparent;
    box-shadow: 0 0 0 0.125rem ${({ theme: { token } }) => `${token.colorPrimaryBg}40`};
    overflow: hidden;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    outline: 0.0625rem ${({ theme: { token } }) => token.colorPrimary} solid;
    outline-offset: -0.0625rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.625rem;
    box-sizing: border-box;
    margin: 0;

    @media (min-width: ${breakpoints.md}px) {
      width: 17.5rem;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    width: 100%;
  }

  .ant-btn-primary {
    align-self: stretch;
    width: 100%;
    padding-left: 0.9375rem;
    padding-right: 0.9375rem;
    background: ${({ theme: { token } }) => token.colorPrimary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    border: none;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSize}px;

    @media (min-width: ${breakpoints.md}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    }

    &:hover {
      background: ${({ theme: { token } }) => token.colorPrimaryHover};
    }
  }

  .validation-error-container {
    width: 100%;
    margin: 16px 0;
  }

  .step-container {
    width: 100%;
    max-width: 1002px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-self: flex-start;
    margin-left: 0;
    color: ${({ theme: { token } }) => token.colorText};
    position: relative;

    @media (max-width: ${breakpoints.md - 1}px) {
      padding-bottom: 5rem;
    }
  }

  @media (max-width: ${breakpoints.md - 1}px) {
    .info-cards-row {
      flex-direction: column;
      gap: 1rem;
    }

    .info-card-wrapper {
      width: 100%;
      margin-bottom: 1rem;
    }

    .association-section {
      flex-direction: column;
      align-items: flex-start;
    }

    .account-select {
      width: 100%;
    }
  }
`;